<script lang="ts">
    import {onMount} from "svelte";
    import {getCity} from "../../utils";
    import {ManagerVehicles} from "../../models/manager-vehicles";

    export let validateURL = "";
    export let iconURL = "";

    let selected;
    let selectedCity;
    let label = [];
    onMount(() => {
        const manager = ManagerVehicles.getInstance();
        manager.selected$.subscribe((next) => {
            selected = next;
            label = [];
            if (!!selected) {
                const {vin, placa, descModeloTASA, descMarca, descModelo} = selected;
                if (vin) {
                    if (placa) {
                        label.push(placa);
                    }
                    if (descModeloTASA) {
                        label.push(descModeloTASA);
                    }
                } else {
                    if (descMarca) {
                        label.push(descMarca);
                    }
                    if (descModelo) {
                        label.push(descModelo);
                    }
                }

            }
        });
        selectedCity = getCity();
    })

    function changeCity() {
        location.href = `/checkout/carrito?ciudad=true&origen=${location.pathname}`;
    }
</script>
<div class="validate box-b sx-15 col-3 py-ii w-100">
    {#if selected}
        <p class=" box-l" style="font-size:15px; font-weight: bold">
            {label.join(' - ')}
            <a href={validateURL}>
                <img height="16" style="margin-left: .5rem" src="/static/storefront/pix/icons/cambiar-vehiculo.svg" alt="Cambiar vehículo">
            </a>
        </p>

    {:else}
        <a href={validateURL} class="validate box col-3 sx-ii pointer w-max-content mx-auto px-ii py-ii">
            <img height="20" src={iconURL} alt="Filtra según vehículo">
            <div class="view-more">Filtra según tu vehículo</div>
        </a>
    {/if}
    <p class="w-max-content box-l sx-i h-100">

        <img src="/static/storefront/pix/icons/ubicacion-ciudad.svg" height="16" alt="Ciudad seleccionada">
        {selectedCity?.name}
        <a on:click={changeCity}>
            <img height="16" style="margin-left: .5rem" src="/static/storefront/pix/icons/cambiar-vehiculo.svg" alt="Cambiar vehículo">
        </a>
    </p>
</div>